export const handleError = (error) => {
  const errorMessage =
    error.response?.data?.error ||
    error.response?.data?.message ||
    error.message ||
    'An unknown error occurred';
  throw new Error(errorMessage);
};
